/* Collection-scoped catalog search: no global/predictive fallback and no cross-world API. */
(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').replace(/ß/g, 'ss');
  const matches = (product, query) => {
    const text = normalize([product.title, product.vendor, product.type, ...(product.tags || [])].join(' '));
    return normalize(query).trim().split(/\s+/).every(word => text.includes(word));
  };
  if (typeof module === 'object') module.exports = { normalize, matches };
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-ss-world-search]').forEach(async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const input = form.elements.q;
    const status = root.querySelector('[data-search-status]');
    const results = root.querySelector('[data-search-results]');
    const more = root.querySelector('[data-search-more]');
    let products = [], visible = 24, loaded = false;
    function element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }
    function render() {
      if (!loaded) return;
      const found = products.filter(product => matches(product, input.value)).sort((a, b) => Number(b.available) - Number(a.available));
      status.textContent = found.length ? `${found.length} ${found.length === 1 ? 'Produkt' : 'Produkte'} gefunden` : 'Keine passenden Produkte in dieser Welt gefunden.';
      results.replaceChildren();
      found.slice(0, visible).forEach(product => {
        const card = element('article', 'ss3-product');
        const art = element('div', 'ss3-product-image');
        const link = element('a'); link.href = product.url;
        if (product.image) {
          const img = element('img'); img.src = product.image; img.alt = product.title; img.loading = 'lazy'; img.width = 540; img.height = 540;
          link.append(img);
        } else link.textContent = product.title;
        art.append(link);
        if (!product.available) art.append(element('span', 'ss3-product-badge', 'Ausverkauft'));
        const copy = element('div', 'ss3-product-copy');
        const heading = element('h2', 'ss3-product-title');
        const titleLink = element('a', '', product.title); titleLink.href = product.url; heading.append(titleLink);
        copy.append(heading, element('p', 'ss3-price', (product.varies ? 'Ab ' : '') + product.price));
        if (product.unit) copy.append(element('p', 'ss3-unit-price', product.unit));
        if (product.mhd) copy.append(element('p', 'ss-product-mhd', product.mhd));
        const details = element('a', 'ss3-product-buy', product.available ? 'Produkt ansehen ↗' : 'Details ansehen ↗'); details.href = product.url;
        copy.append(details); card.append(art, copy); results.append(card);
      });
      more.hidden = found.length <= visible;
    }
    form.addEventListener('submit', event => { event.preventDefault(); visible = 24; render(); });
    input.addEventListener('input', () => { visible = 24; render(); });
    more.addEventListener('click', () => { visible += 24; render(); });
    try {
      if (!root.dataset.collectionUrl) { loaded = true; render(); return; }
      const seen = new Set();
      let page = 1, pages = 1;
      do {
        const url = new URL(root.dataset.collectionUrl, location.origin);
        url.searchParams.set('view', 'ss-search-data');
        url.searchParams.set('page', String(page));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        // This is a Liquid view, not Shopify's built-in JSON collection endpoint.
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw Error('Search load failed');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw Error('Invalid search response');
        pages = Math.max(1, Number(data.pages) || 1);
        data.products.forEach(product => { if (!seen.has(product.id)) { seen.add(product.id); products.push(product); } });
        page++;
      } while (page <= pages);
      loaded = true; render();
    } catch (_) {
      status.textContent = 'Die Suche konnte nicht geladen werden. Über den Link unten kommst du direkt zur Collection.';
    }
  });
})();
